import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { makePost } from "@culturehq/client";
import { EmailField, Form, Panel, SubmitButton, Success } from "@culturehq/components";

import { useAsyncAction } from "app/hooks";
import { Trans } from "app/utils";

import Typography from "components/common/Typography";

type ResetPasswordRequestProps = {
  match?: any;
};

const ResetPasswordRequest: React.FC<ResetPasswordRequestProps> = ({ match }) => {
  const [success, setSuccess] = useState<boolean>(false);
  const { params: { email: savedEmail } } = match;
  const { onTrigger: onSubmit } = useAsyncAction(
    useCallback(
      async () => {
        await makePost("/password_resets", { email: savedEmail });
        setSuccess(true);
      },
      [savedEmail, setSuccess]
    )
  );

  return (
    <Panel className="max-width-360">
      <Panel.Body>
        {success && (
          <Success>
            <Trans>
              Please check your e-mail. A link to reset your password has been
              sent to your inbox. If you don&#39;t receive an e-mail within 5
              minutes, please check your spam filter or contact support.
            </Trans>
          </Success>
        )}
        {!success && (
          <Form onSubmit={onSubmit}>
            <EmailField name="email" required autoFocus value={savedEmail} disabled>
              <Trans>Email Address</Trans>
            </EmailField>
            <SubmitButton primary fillParent>
              {submitting => (submitting
                ? <Trans>Submitting...</Trans>
                : <Trans>Reset Password</Trans>
              )}
            </SubmitButton>
          </Form>
        )}
      </Panel.Body>
      <Panel.Footer>
        <Typography textCenter>
          <Link to="/login">
            <Trans>Back to sign in page</Trans>
          </Link>
        </Typography>
      </Panel.Footer>
    </Panel>
  );
};

export default ResetPasswordRequest;
